import {useContext, useEffect, useState} from 'react'
import {Col, Flex, Form, Modal, Row} from 'antd'
import {useIntl} from 'react-intl'
import {getRequest, postRequest, putRequest} from '../../../../services/base'
import {NavContext} from '../../../../context/global_context'
import {SET_SHOW_SYSTEM_POPUP, SystemContext} from '../context/context'
import InputText from '../../../common/InputText'
import SelectInput from '../../../common/SelectInput'
import Button from '../../../common/Button'
import {notifyError} from '../../../../utils/notifications'
import {getLocalStorageData} from '../../../../utils/LocalStorageAccess'
import {MAKE_ID} from '../../../../constants/common'

const SystemFormModal = (props) => {
  const intl = useIntl()
  const [state, dispatch] = useContext(SystemContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [form] = Form.useForm()
  const [makeOptions, setMakeOptions] = useState([])

  const selected = state?.selected_system || {}
  const isEditing = !!selected?.id
  const localStorageMake = getLocalStorageData(MAKE_ID)

  const closeFormPopup = () => {
    dispatch({ type: SET_SHOW_SYSTEM_POPUP, data: false })
    form.resetFields()
  }

  const getInitialValues = () => ({
    is_create: !isEditing,
    id: selected?.id || undefined,
    system_id: selected?.system_id || '',
    name: selected?.name || '',
    make: selected?.make || localStorageMake || navState?.make || '',
  })

  const fetchMakes = async () => {
    let res = await getRequest(`/api/users/make_options/`)
    // Loaded once when the popup opens, not a search, so a toast is right here.
    if (res?.status === false) {
      notifyError(navDispatch, intl.formatMessage({ id: 'generic.makesLoadError' }))
      return
    }
    const results = res?.results || []
    setMakeOptions(
      results.map((item) => ({ value: item.id, label: item.name }))
    )
  }

  useEffect(() => {
    if (!state.show_system_popup) return
    if (localStorageMake || navState?.make) {
      const make = localStorageMake || navState?.make
      setMakeOptions([{ value: make, label: make }])
    } else {
      fetchMakes()
    }
  }, [state.show_system_popup])

  useEffect(() => {
    if (!state.show_system_popup) return
    form.setFieldsValue(getInitialValues())
  }, [state.show_system_popup])

  const saveSystem = async (values) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'system.save' }),
        showLoader: true,
      },
      notification: {},
    })

    const formData = new FormData()
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value)
      }
    })

    const res = isEditing
      ? await putRequest(`/api/system/${selected.id}/`, formData)
      : await postRequest(`/api/system/`, formData)

    navDispatch({
      type: 'loader',
      data: { showLoader: false },
      notification: {},
    })

    if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({
            id: isEditing ? 'system.updateSuccess' : 'system.saveSuccess',
          }),
        },
      })
      props.getSystemListData()
      closeFormPopup()
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'system.saveError' }),
        },
      })
    }
  }

  return (
    <Modal
      open={state.show_system_popup}
      title={
        isEditing
          ? intl.formatMessage({ id: 'system.updateTitle' })
          : intl.formatMessage({ id: 'system.createTitle' })
      }
      width="50%"
      centered={true}
      footer={null}
      closable={true}
      onCancel={closeFormPopup}
    >
      <div className="container">
        <Form
          id="system-form"
          name="system-form"
          form={form}
          layout="vertical"
          onFinish={saveSystem}
        >
          <InputText name="is_create" hidden={true} isRequired={false} />
          <InputText name="id" hidden={true} isRequired={false} />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <InputText
                name="system_id"
                label={intl.formatMessage({ id: 'system.systemId' })}
                isRequired={true}
              />
            </Col>
            <Col span={12}>
              <InputText
                name="name"
                label={intl.formatMessage({ id: 'system.name' })}
                isRequired={true}
              />
            </Col>
            <Col span={12}>
              <SelectInput
                name="make"
                label={intl.formatMessage({ id: 'system.make' })}
                options={makeOptions}
                placeholder={intl.formatMessage({ id: 'system.make' })}
                isRequired={true}
                disabled={isEditing || Boolean(localStorageMake)}
                allowClear={true}
                showSearch={true}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Flex justify="end" className="py-4">
                <Button onClick={() => form.submit()} type="primary">
                  {intl.formatMessage({ id: 'system.save' })}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default SystemFormModal
